import { simMod } from './Module.config'
import { getCompanyID, getCompanyName } from './api/api'
import * as LMS from './LMS'
import { User, ElectricalCode } from './Types'
import { getElectricalCode } from './App.config'

export const getUser = async (): Promise<User> => {
    console.log('Initializing user...')
    const scormUsername: string = LMS.getStudentName()
    const scormUserID: string = LMS.getStudentID()
    const companyID: string = getCompanyID()
    const companyName: string = await getCompanyName(companyID)
    const electricalCode: ElectricalCode = getElectricalCode()
    const isScormStudent = scormUserID === '' || scormUserID === undefined ? false : true

    const uname: string = isScormStudent
        ? scormUsername
        : simMod.userName

    const uid: string = isScormStudent
        ? scormUserID
        : simMod.userID

    const user: User = {
        userId: uid,
        userName: uname,
        companyId: companyID,
        companyName: companyName,
        moduleId: simMod.solverModule,
        electricalCode: electricalCode
    }

    console.table(user)
    return user
}